/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Images/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import ImageSlot from './ImageSlot/index'
import React from 'react'
import styles from './view.module.css'
import useListItemDataOnChange from './useListItemDataOnChange.js'
import useListItemDataOnSubmit from './useListItemDataOnSubmit.js'



/** @type {import('Simple/types.js').View} */
export default function Images({
  children,
  viewPath = "/DesignSystem/CaptureImageSeries/Content/Active/Content/Images"
  
}) {
let imagesValueData = fromData.useDataValue({ viewPath,
context: 'images',
})
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
  return (<React.Fragment
>
<div
  data-testid="Images.List"
  data-view-path={viewPath}
 style={{'--mt-1-Z2tKXei': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM}}
 className={`views-block ${styles.List}`}
>
{Array.isArray(imagesValueData) && imagesValueData.map((item, index, list) => 
<ListItem
        key={item?.id ?? item?._id ?? index}
        context="image"
        item={item}
        index={index}
        list={list}
        hasItemKey={false}
        parentViewPath={viewPath}
        viewPath={`${viewPath}/ImageSlot(${item?.id ?? item?._id ?? index})`}
      >
<ImageSlot
 index={index} indexReverse={list.length - index} isFirst={index === 0} isLast={index === list.length - 1}
 item={item}
 viewPath={`${viewPath}/ImageSlot(${item?.id ?? item?._id ?? index})`}
/>
</ListItem>
)}
</div>
{children}
</React.Fragment>)
}

  function ListItem(props) {
    let valueItem = React.useMemo(() => ({
      index: props.index,
      indexReverse: props.list.length - props.index,
      isFirst: props.index === 0,
      isLast: props.index === props.list.length - 1,
    }), [props.index, props.list])
    let onChange = useListItemDataOnChange({ ...props, viewPath: props.parentViewPath })
    let onSubmit = useListItemDataOnSubmit(props)
    
    return (
      <fromData.DataProvider
      context={props.context}
      value={props.item}
      onChange={onChange}
      onSubmit={onSubmit}
      viewPath={props.viewPath}
    >
      <fromData.DataProvider
        context={`${props.context}_item`}
        value={valueItem}
        viewPath={props.viewPath}
      >
        {props.children}
      </fromData.DataProvider>
    </fromData.DataProvider>
    )
  }